import request from 'superagent';
import { getUserData } from './API';

export default async function getUserFilters() {
  const user = getUserData();
  let filters = [];

  // Set up the district filter.
  if (user.district) {
    const districtName = user.district.label;
    const filter = {
      column: "district",
      operator: "IN",
      values: [districtName],
    }
    filters.push(filter)
  }

  const hasAllSchools = user.reportingRole && user.reportingRole.scopes && user.reportingRole.scopes.schools && user.reportingRole.scopes.schools.length === 1 && user.reportingRole.scopes.schools[0] === "*";

  // Filter down to individual schools if the user is a school admin, or a district admin with a subdistrict, or a reporting role with specific schools.
  const shouldFilterSchools = (user.userType === "SCHOOL_ADMIN" && (!user.reportingRole || (user.reportingRole && !hasAllSchools))) ||
                              (user.userType === "DISTRICT_ADMIN" && (user.subdistrictId || (user.reportingRole && !hasAllSchools))) ||
                              (user.reportingRole && !hasAllSchools)

  // Set up the school filter.
  if (user.schools && user.schools.length && shouldFilterSchools) {
    let schools = user.schools.map(school=>school.label);

    const filter = {
      column: "school",
      operator: "IN",
      values: schools,
    }
    filters.push(filter);
  }

  return filters;
}


function customEncode(str) {
  // Get the characters that encodeURIComponent() encodes but encodeURI() doesn't
  const reservedChars = /[,\/?:@&=+$#]/g;

  // Encode only the characters that encodeURIComponent() encodes but encodeURI() doesn't
  let encodedStr = str.replace(reservedChars, function(char) {
    return '%' + char.charCodeAt(0).toString(16);
  });

  // Return the encoded string
  return encodedStr;
}

export async function getDomoEmbedSrc(itemId, filters) {
  const apiUrl = process.env.DOMO_API_SERVER_URL + '/domo/embed'
  try {
    const response = await request.post(apiUrl).send({itemId, filters})
    const { embedToken, embedUrl } = response.body;
    let queryString = '';
    return `
    <html>
      <body>
        <form id="form" action='${embedUrl}${queryString}' method="post">
          <input type="hidden" name="embedToken" value='${embedToken}'>
        </form>
        <script>
          document.getElementById("form").submit();
        </script>
      </body>
    </html>`;
  } catch (e) {
    console.error('Domo request error', e);
  }
}